export default __webpack_public_path__ + "assets/maplogo.69590e51.svg";